// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Role$ReactHooksTemplate = require("../settings/role.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var EmailFromId$ReactHooksTemplate = require("../surveys/emailFromId.res.js");
var Organization$ReactHooksTemplate = require("../settings/organization.res.js");
var ReportAutomailer$ReactHooksTemplate = require("./reportAutomailer.res.js");
var CurrentOrganization$ReactHooksTemplate = require("../CurrentOrganization.res.js");
var ReportAutomailerModal$ReactHooksTemplate = require("./ReportAutomailerModal.res.js");

var initialState_selectedConfig = ReportAutomailer$ReactHooksTemplate.empty();

var initialState = {
  loading: true,
  automailers: /* [] */0,
  showModal: false,
  formAction: "Create",
  selectedConfig: initialState_selectedConfig,
  fromIds: /* [] */0,
  reportOptions: /* [] */0,
  placeholderChips: /* [] */0,
  roles: /* [] */0,
  formErrors: /* [] */0
};

function reducer(state, action) {
  if (typeof action !== "object") {
    return {
            loading: true,
            automailers: state.automailers,
            showModal: state.showModal,
            formAction: state.formAction,
            selectedConfig: state.selectedConfig,
            fromIds: state.fromIds,
            reportOptions: state.reportOptions,
            placeholderChips: state.placeholderChips,
            roles: state.roles,
            formErrors: state.formErrors
          };
  }
  switch (action.TAG) {
    case "FetchAutomailersCompleted" :
        return {
                loading: false,
                automailers: action._0,
                showModal: state.showModal,
                formAction: state.formAction,
                selectedConfig: state.selectedConfig,
                fromIds: state.fromIds,
                reportOptions: state.reportOptions,
                placeholderChips: state.placeholderChips,
                roles: state.roles,
                formErrors: state.formErrors
              };
    case "FetchFromIdsCompleted" :
        return {
                loading: state.loading,
                automailers: state.automailers,
                showModal: state.showModal,
                formAction: state.formAction,
                selectedConfig: state.selectedConfig,
                fromIds: action._0,
                reportOptions: state.reportOptions,
                placeholderChips: state.placeholderChips,
                roles: state.roles,
                formErrors: state.formErrors
              };
    case "FetchReportOptionsCompleted" :
        return {
                loading: state.loading,
                automailers: state.automailers,
                showModal: state.showModal,
                formAction: state.formAction,
                selectedConfig: state.selectedConfig,
                fromIds: state.fromIds,
                reportOptions: action._0,
                placeholderChips: state.placeholderChips,
                roles: state.roles,
                formErrors: state.formErrors
              };
    case "FetchPlaceholderChipsCompleted" :
        return {
                loading: state.loading,
                automailers: state.automailers,
                showModal: state.showModal,
                formAction: state.formAction,
                selectedConfig: state.selectedConfig,
                fromIds: state.fromIds,
                reportOptions: state.reportOptions,
                placeholderChips: action._0,
                roles: state.roles,
                formErrors: state.formErrors
              };
    case "FetchRolesCompleted" :
        return {
                loading: state.loading,
                automailers: state.automailers,
                showModal: state.showModal,
                formAction: state.formAction,
                selectedConfig: state.selectedConfig,
                fromIds: state.fromIds,
                reportOptions: state.reportOptions,
                placeholderChips: state.placeholderChips,
                roles: action._0,
                formErrors: state.formErrors
              };
    case "SetShowModal" :
        return {
                loading: state.loading,
                automailers: state.automailers,
                showModal: action._0,
                formAction: state.formAction,
                selectedConfig: state.selectedConfig,
                fromIds: state.fromIds,
                reportOptions: state.reportOptions,
                placeholderChips: state.placeholderChips,
                roles: state.roles,
                formErrors: /* [] */0
              };
    case "SetFormAction" :
        return {
                loading: state.loading,
                automailers: state.automailers,
                showModal: state.showModal,
                formAction: action._0,
                selectedConfig: state.selectedConfig,
                fromIds: state.fromIds,
                reportOptions: state.reportOptions,
                placeholderChips: state.placeholderChips,
                roles: state.roles,
                formErrors: state.formErrors
              };
    case "SetSelectedConfig" :
        return {
                loading: state.loading,
                automailers: state.automailers,
                showModal: state.showModal,
                formAction: state.formAction,
                selectedConfig: action._0,
                fromIds: state.fromIds,
                reportOptions: state.reportOptions,
                placeholderChips: state.placeholderChips,
                roles: state.roles,
                formErrors: state.formErrors
              };
    case "SetFormErrors" :
        return {
                loading: state.loading,
                automailers: state.automailers,
                showModal: state.showModal,
                formAction: state.formAction,
                selectedConfig: state.selectedConfig,
                fromIds: state.fromIds,
                reportOptions: state.reportOptions,
                placeholderChips: state.placeholderChips,
                roles: state.roles,
                formErrors: action._0
              };
    case "DeleteAutomailer" :
        var toDelete = action._0;
        return {
                loading: state.loading,
                automailers: Belt_List.keep(state.automailers, (function (a) {
                        return Caml_obj.notequal(ReportAutomailer$ReactHooksTemplate.id(a), ReportAutomailer$ReactHooksTemplate.id(toDelete));
                      })),
                showModal: state.showModal,
                formAction: state.formAction,
                selectedConfig: state.selectedConfig,
                fromIds: state.fromIds,
                reportOptions: state.reportOptions,
                placeholderChips: state.placeholderChips,
                roles: state.roles,
                formErrors: state.formErrors
              };
    
  }
}

function ReportAutomailers(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useContext(CurrentOrganization$ReactHooksTemplate.authContext);
  var organizationTimeZone = Organization$ReactHooksTemplate.timeZone(match$1[0]);
  var fetchFromIds = function (param) {
    return Js_promise.then_((function (json) {
                  return Promise.resolve(Belt_List.fromArray(Json_decode.field("email_from_ids", (function (param) {
                                        return Json_decode.array(EmailFromId$ReactHooksTemplate.decode, param);
                                      }), json)));
                }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/email_from_ids"));
  };
  var fetchReportOptions = function (param) {
    return Js_promise.then_((function (json) {
                  var reports = Json_decode.field("data", (function (param) {
                          return Json_decode.field("reports", (function (param) {
                                        return Json_decode.array(ReportAutomailer$ReactHooksTemplate.decodeReportOption, param);
                                      }), param);
                        }), json);
                  return Promise.resolve(Belt_List.fromArray(reports));
                }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/reports/list"));
  };
  var fetchAutomailers = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/report_automailers", (function (param) {
                  return Json_decode.field("data", (function (param) {
                                return Json_decode.field("report_automailers", (function (param) {
                                              return Json_decode.array(ReportAutomailer$ReactHooksTemplate.decode, param);
                                            }), param);
                              }), param);
                }));
  };
  var fetchPlaceholderChips = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/report_automailers/placeholders", (function (param) {
                  return Json_decode.field("data", (function (param) {
                                return Json_decode.field("placeholders", (function (param) {
                                              return Json_decode.array(ReportAutomailer$ReactHooksTemplate.decodePlaceholderChip, param);
                                            }), param);
                              }), param);
                }));
  };
  var fetchRoles = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/roles", (function (param) {
                  return Json_decode.field("roles", (function (param) {
                                return Json_decode.list(Role$ReactHooksTemplate.decode, param);
                              }), param);
                }));
  };
  React.useEffect((function (param) {
          Curry._1(dispatch, "FetchInProgress");
          Js_promise.$$catch((function (e) {
                  console.log("Report automailers fetch failed");
                  console.log(e);
                  Curry._1(dispatch, {
                        TAG: "FetchAutomailersCompleted",
                        _0: /* [] */0
                      });
                  return Promise.resolve();
                }), Js_promise.then_((function (param) {
                      Curry._1(dispatch, {
                            TAG: "FetchFromIdsCompleted",
                            _0: param[0]
                          });
                      Curry._1(dispatch, {
                            TAG: "FetchReportOptionsCompleted",
                            _0: param[1]
                          });
                      Curry._1(dispatch, {
                            TAG: "FetchAutomailersCompleted",
                            _0: Belt_List.fromArray(param[2])
                          });
                      Curry._1(dispatch, {
                            TAG: "FetchRolesCompleted",
                            _0: param[3]
                          });
                      return Promise.resolve();
                    }), Promise.all([
                        fetchFromIds(),
                        fetchReportOptions(),
                        fetchAutomailers(),
                        fetchRoles()
                      ])));
          Js_promise.$$catch((function (param) {
                  return Promise.resolve();
                }), Js_promise.then_((function (placeholderChips) {
                      Curry._1(dispatch, {
                            TAG: "FetchPlaceholderChipsCompleted",
                            _0: Belt_List.fromArray(placeholderChips)
                          });
                      return Promise.resolve();
                    }), fetchPlaceholderChips()));
        }), []);
  var openCreateModal = function (param) {
    Curry._1(dispatch, {
          TAG: "SetFormAction",
          _0: "Create"
        });
    Curry._1(dispatch, {
          TAG: "SetSelectedConfig",
          _0: ReportAutomailer$ReactHooksTemplate.empty()
        });
    Curry._1(dispatch, {
          TAG: "SetShowModal",
          _0: true
        });
  };
  var closeModal = function (param) {
    Curry._1(dispatch, {
          TAG: "SetFormErrors",
          _0: /* [] */0
        });
    Curry._1(dispatch, {
          TAG: "SetShowModal",
          _0: false
        });
  };
  var refetchAutomailers = function (param) {
    Js_promise.$$catch((function (param) {
            return Promise.resolve();
          }), Js_promise.then_((function (automailers) {
                Curry._1(dispatch, {
                      TAG: "FetchAutomailersCompleted",
                      _0: Belt_List.fromArray(automailers)
                    });
                return Promise.resolve();
              }), fetchAutomailers()));
  };
  var onFormSubmit = function (param) {
    var config = state.selectedConfig;
    var params = {};
    params["report_automailer"] = ReportAutomailer$ReactHooksTemplate.encode(config);
    var match = state.formAction;
    var submitPromise;
    if (match === "Create") {
      submitPromise = Http$ReactHooksTemplate.fetchPostJSON("/api/v1/report_automailers", params);
    } else {
      var id = String(Belt_Option.getExn(ReportAutomailer$ReactHooksTemplate.id(config)));
      submitPromise = Http$ReactHooksTemplate.fetchPostJSON("/api/v1/report_automailers/" + id + "/update", params);
    }
    Js_promise.$$catch((function (param) {
            return Promise.resolve();
          }), Js_promise.then_((function (response) {
                var status = Json_decode.field("status", (function (param) {
                        return Json_decode.withDefault("failed", Json_decode.string, param);
                      }), response);
                var errors = Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                            return Json_decode.field("errors", (function (param) {
                                          return Json_decode.list(Json_decode.string, param);
                                        }), param);
                          }), response), /* [] */0);
                if (status === "success") {
                  Curry._1(dispatch, {
                        TAG: "SetFormErrors",
                        _0: /* [] */0
                      });
                  Curry._1(dispatch, {
                        TAG: "SetFormErrors",
                        _0: /* [] */0
                      });
                  Curry._1(dispatch, {
                        TAG: "SetShowModal",
                        _0: false
                      });
                  refetchAutomailers();
                } else {
                  Curry._1(dispatch, {
                        TAG: "SetFormErrors",
                        _0: errors
                      });
                }
                return Promise.resolve();
              }), submitPromise));
  };
  var currentNameTrimmed = ReportAutomailer$ReactHooksTemplate.name(state.selectedConfig).trim();
  var isNameTaken = false;
  if (currentNameTrimmed !== "") {
    var match$2 = state.formAction;
    var tmp;
    if (match$2 === "Create") {
      tmp = Belt_List.some(state.automailers, (function (a) {
              return ReportAutomailer$ReactHooksTemplate.name(a).trim() === currentNameTrimmed;
            }));
    } else {
      var currentId = ReportAutomailer$ReactHooksTemplate.id(state.selectedConfig);
      tmp = Belt_List.some(state.automailers, (function (a) {
              if (Caml_obj.notequal(ReportAutomailer$ReactHooksTemplate.id(a), currentId)) {
                return ReportAutomailer$ReactHooksTemplate.name(a).trim() === currentNameTrimmed;
              } else {
                return false;
              }
            }));
    }
    isNameTaken = tmp;
  }
  var nameTakenErrorStr = isNameTaken ? "Name has already been taken" : "";
  var hasRecipients = Belt_List.length(ReportAutomailer$ReactHooksTemplate.toEmails(state.selectedConfig)) > 0 || Belt_List.length(Belt_Option.getWithDefault(ReportAutomailer$ReactHooksTemplate.recipientRoleNames(state.selectedConfig), /* [] */0)) > 0;
  var selectedRecurrence = ReportAutomailer$ReactHooksTemplate.recurrence(state.selectedConfig);
  var hasWeekday = selectedRecurrence.preset !== "weekly" || Belt_List.length(selectedRecurrence.byDay) > 0;
  var hasDayOfMonth = selectedRecurrence.preset !== "monthly" || Belt_Option.isSome(selectedRecurrence.byMonthDay);
  var isFormValid = currentNameTrimmed.length > 0 && !isNameTaken && selectedRecurrence.preset.length > 0 && ReportAutomailer$ReactHooksTemplate.sendTime(state.selectedConfig).length > 0 && ReportAutomailer$ReactHooksTemplate.schedule(state.selectedConfig).length > 0 && ReportAutomailer$ReactHooksTemplate.fromEmail(state.selectedConfig).trim().length > 0 && hasRecipients && hasWeekday && hasDayOfMonth && ReportAutomailer$ReactHooksTemplate.isRecurrenceValid(selectedRecurrence) && ReportAutomailer$ReactHooksTemplate.subject(state.selectedConfig).trim().length > 0 && Belt_List.length(ReportAutomailer$ReactHooksTemplate.reportIds(state.selectedConfig)) > 0;
  var match$3 = state.formAction;
  var formActionStr;
  formActionStr = match$3 === "Create" ? "create" : "update";
  if (state.loading) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          className: "w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"
                                        }),
                                    JsxRuntime.jsx("span", {
                                          children: "Loading Report Automailers...",
                                          className: "text-sm sm:text-base text-gray-600"
                                        })
                                  ],
                                  className: "flex items-center space-x-3"
                                }),
                            className: "flex items-center justify-center py-12 sm:py-20"
                          }),
                      className: "bg-white rounded-lg sm:rounded-xl shadow border border-gray-200 overflow-hidden"
                    }),
                className: "w-full max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:py-8"
              });
  } else {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx("span", {
                                                        children: "📧",
                                                        className: "text-lg sm:text-xl"
                                                      }),
                                                  className: "flex-shrink-0 flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("h1", {
                                                          children: "Report Automailer",
                                                          className: "text-xl sm:text-2xl font-bold text-gray-900 truncate"
                                                        }),
                                                    JsxRuntime.jsx("p", {
                                                          children: "Schedule reports to be sent by email. Configure recipients, frequency, and which reports to include.",
                                                          className: "text-xs sm:text-sm text-gray-600 mt-0.5"
                                                        })
                                                  ],
                                                  className: "min-w-0"
                                                })
                                          ],
                                          className: "flex items-start sm:items-center gap-3 min-w-0"
                                        }),
                                    className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
                                  }),
                              className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-4 py-4 sm:px-6 sm:py-6 border-b border-gray-200"
                            }),
                        className: "bg-white rounded-lg sm:rounded-xl shadow border border-gray-200 overflow-hidden mb-4 sm:mb-6"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      children: JsxRuntime.jsx("span", {
                                                            children: "📋",
                                                            className: "text-base sm:text-lg"
                                                          }),
                                                      className: "flex-shrink-0 flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-white border border-gray-200 shadow-sm"
                                                    }),
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("h2", {
                                                              children: "Configurations",
                                                              className: "text-base sm:text-lg font-bold text-gray-900 tracking-tight"
                                                            }),
                                                        JsxRuntime.jsx("p", {
                                                              children: "Manage report automailer configurations",
                                                              className: "text-xs sm:text-sm text-gray-500 mt-0.5"
                                                            })
                                                      ],
                                                      className: "min-w-0"
                                                    }),
                                                JsxRuntime.jsx("span", {
                                                      children: String(List.length(state.automailers)) + " config" + (
                                                        List.length(state.automailers) === 1 ? "" : "s"
                                                      ),
                                                      className: "inline-flex items-center px-2.5 py-0.5 sm:px-3 sm:py-1 text-xs font-semibold text-blue-700 bg-blue-100 rounded-full border border-blue-200/60"
                                                    })
                                              ],
                                              className: "flex flex-wrap items-center gap-2 sm:gap-3 min-w-0"
                                            }),
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("span", {
                                                      children: "+",
                                                      className: "mr-2 text-base leading-none"
                                                    }),
                                                "Create New"
                                              ],
                                              className: "w-full sm:w-auto inline-flex items-center justify-center px-4 py-3 sm:py-2.5 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 shadow-sm min-h-[44px]",
                                              onClick: (function (param) {
                                                  openCreateModal();
                                                })
                                            })
                                      ],
                                      className: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:flex-wrap"
                                    }),
                                className: "bg-gradient-to-r from-gray-50 via-white to-gray-50 px-4 py-4 sm:px-6 sm:py-5 border-b border-gray-200"
                              }),
                          JsxRuntime.jsx("div", {
                                children: List.length(state.automailers) > 0 ? JsxRuntime.jsxs("table", {
                                        children: [
                                          JsxRuntime.jsx("thead", {
                                                children: JsxRuntime.jsxs("tr", {
                                                      children: [
                                                        JsxRuntime.jsx("th", {
                                                              children: "Name",
                                                              className: "text-left py-3 px-3 sm:py-3.5 sm:px-5 font-semibold text-gray-700 uppercase tracking-wider text-xs"
                                                            }),
                                                        JsxRuntime.jsx("th", {
                                                              children: "Send",
                                                              className: "text-left py-3 px-3 sm:py-3.5 sm:px-5 font-semibold text-gray-700 uppercase tracking-wider text-xs"
                                                            }),
                                                        JsxRuntime.jsx("th", {
                                                              children: "Reports",
                                                              className: "text-left py-3 px-3 sm:py-3.5 sm:px-5 font-semibold text-gray-700 uppercase tracking-wider text-xs"
                                                            }),
                                                        JsxRuntime.jsx("th", {
                                                              children: "Actions",
                                                              className: "text-right py-3 px-3 sm:py-3.5 sm:px-5 font-semibold text-gray-700 uppercase tracking-wider text-xs w-24 sm:w-28"
                                                            })
                                                      ],
                                                      className: "bg-gray-50 border-b border-gray-200"
                                                    })
                                              }),
                                          JsxRuntime.jsx("tbody", {
                                                children: $$Array.of_list(Belt_List.map(state.automailers, (function (config) {
                                                            var configRecurrence = ReportAutomailer$ReactHooksTemplate.recurrence(config);
                                                            var match = configRecurrence.preset;
                                                            var frequencyLabel;
                                                            switch (match) {
                                                              case "custom" :
                                                                  frequencyLabel = "Custom";
                                                                  break;
                                                              case "daily" :
                                                                  frequencyLabel = "Daily";
                                                                  break;
                                                              case "monthly" :
                                                                  frequencyLabel = "Monthly";
                                                                  break;
                                                              case "weekly" :
                                                                  frequencyLabel = "Weekly";
                                                                  break;
                                                              default:
                                                                frequencyLabel = "";
                                                            }
                                                            var sendTime = ReportAutomailer$ReactHooksTemplate.sendTime(config);
                                                            var hasNewSchedule = frequencyLabel !== "" && sendTime.length > 0;
                                                            var __x = ReportAutomailer$ReactHooksTemplate.recurrenceSummary(config);
                                                            var summary = Belt_Option.getWithDefault(__x, ReportAutomailer$ReactHooksTemplate.previewSummary(configRecurrence, sendTime, organizationTimeZone));
                                                            var badgeClass = hasNewSchedule ? "bg-emerald-100 text-emerald-800 border-emerald-300" : "bg-gray-100 text-gray-700 border-gray-300";
                                                            return JsxRuntime.jsxs("tr", {
                                                                        children: [
                                                                          JsxRuntime.jsx("td", {
                                                                                children: JsxRuntime.jsx("div", {
                                                                                      children: ReportAutomailer$ReactHooksTemplate.name(config),
                                                                                      className: "font-medium text-gray-900 truncate max-w-[180px] sm:max-w-none"
                                                                                    }),
                                                                                className: "px-3 py-3 sm:px-5 sm:py-4"
                                                                              }),
                                                                          JsxRuntime.jsx("td", {
                                                                                children: hasNewSchedule ? JsxRuntime.jsxs("div", {
                                                                                        children: [
                                                                                          JsxRuntime.jsx("span", {
                                                                                                children: summary,
                                                                                                className: "inline-flex w-fit items-center text-xs font-medium px-2 sm:px-2.5 py-0.5 sm:py-1 rounded-md border " + badgeClass
                                                                                              }),
                                                                                          JsxRuntime.jsx("span", {
                                                                                                children: organizationTimeZone,
                                                                                                className: "text-[11px] text-gray-500"
                                                                                              })
                                                                                        ],
                                                                                        className: "flex flex-col gap-1"
                                                                                      }) : JsxRuntime.jsx("span", {
                                                                                        children: "Not configured",
                                                                                        className: "inline-flex items-center text-xs font-medium px-2 sm:px-2.5 py-0.5 sm:py-1 rounded-md border " + badgeClass
                                                                                      }),
                                                                                className: "px-3 py-3 sm:px-5 sm:py-4"
                                                                              }),
                                                                          JsxRuntime.jsx("td", {
                                                                                children: JsxRuntime.jsxs("div", {
                                                                                      children: [
                                                                                        $$Array.of_list(Belt_List.map(ReportAutomailer$ReactHooksTemplate.reports(config), (function (r) {
                                                                                                    return JsxRuntime.jsx("span", {
                                                                                                                children: r.name,
                                                                                                                className: "inline-flex items-center text-xs font-medium px-2 sm:px-2.5 py-0.5 sm:py-1 rounded-md bg-blue-50 text-blue-800 border border-blue-200 truncate max-w-[120px] sm:max-w-none"
                                                                                                              }, String(r.id));
                                                                                                  }))),
                                                                                        List.length(ReportAutomailer$ReactHooksTemplate.reports(config)) === 0 ? JsxRuntime.jsx("span", {
                                                                                                children: "No reports",
                                                                                                className: "text-gray-400 text-xs italic"
                                                                                              }) : null
                                                                                      ],
                                                                                      className: "flex flex-wrap gap-1.5 sm:gap-2 max-w-[200px] sm:max-w-none"
                                                                                    }),
                                                                                className: "px-3 py-3 sm:px-5 sm:py-4"
                                                                              }),
                                                                          JsxRuntime.jsx("td", {
                                                                                children: JsxRuntime.jsxs("div", {
                                                                                      children: [
                                                                                        JsxRuntime.jsx("button", {
                                                                                              children: JsxRuntime.jsx("img", {
                                                                                                    className: "h-4 w-4",
                                                                                                    alt: "Edit",
                                                                                                    src: Image$ReactHooksTemplate.edit
                                                                                                  }),
                                                                                              className: "min-w-[44px] min-h-[44px] sm:min-w-0 sm:min-h-0 p-2.5 sm:p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500/30",
                                                                                              title: "Edit",
                                                                                              onClick: (function (param) {
                                                                                                  Curry._1(dispatch, {
                                                                                                        TAG: "SetFormAction",
                                                                                                        _0: "Update"
                                                                                                      });
                                                                                                  Curry._1(dispatch, {
                                                                                                        TAG: "SetSelectedConfig",
                                                                                                        _0: config
                                                                                                      });
                                                                                                  Curry._1(dispatch, {
                                                                                                        TAG: "SetShowModal",
                                                                                                        _0: true
                                                                                                      });
                                                                                                })
                                                                                            }),
                                                                                        JsxRuntime.jsx("button", {
                                                                                              children: JsxRuntime.jsx("img", {
                                                                                                    className: "h-4 w-4",
                                                                                                    alt: "Delete",
                                                                                                    src: Image$ReactHooksTemplate.trashGrey
                                                                                                  }),
                                                                                              className: "min-w-[44px] min-h-[44px] sm:min-w-0 sm:min-h-0 p-2.5 sm:p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-red-500/30",
                                                                                              title: "Delete",
                                                                                              onClick: (function (param) {
                                                                                                  var id = String(Belt_Option.getExn(ReportAutomailer$ReactHooksTemplate.id(config)));
                                                                                                  Curry._1(dispatch, {
                                                                                                        TAG: "DeleteAutomailer",
                                                                                                        _0: config
                                                                                                      });
                                                                                                  Http$ReactHooksTemplate.fetchPostJSON("/api/v1/report_automailers/" + id + "/delete", {});
                                                                                                })
                                                                                            })
                                                                                      ],
                                                                                      className: "flex items-center justify-end gap-0.5 sm:space-x-1"
                                                                                    }),
                                                                                className: "px-3 py-3 sm:px-5 sm:py-4 text-right"
                                                                              })
                                                                        ],
                                                                        className: "hover:bg-gray-50 transition-colors duration-150"
                                                                      }, String(Belt_Option.getWithDefault(ReportAutomailer$ReactHooksTemplate.id(config), 0)));
                                                          }))),
                                                className: "divide-y divide-gray-100"
                                              })
                                        ],
                                        className: "w-full text-sm min-w-[600px]"
                                      }) : JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      children: JsxRuntime.jsx("span", {
                                                            children: "📧",
                                                            className: "text-3xl sm:text-4xl"
                                                          }),
                                                      className: "w-16 h-16 sm:w-20 sm:h-20 rounded-xl sm:rounded-2xl bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center border border-gray-200 shadow-inner"
                                                    }),
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("h3", {
                                                              children: "No configurations yet",
                                                              className: "text-base sm:text-lg font-semibold text-gray-900"
                                                            }),
                                                        JsxRuntime.jsx("p", {
                                                              children: "Create a report automailer to schedule reports and send them by email to your team.",
                                                              className: "text-xs sm:text-sm text-gray-500 mt-1.5 sm:mt-2 leading-relaxed"
                                                            })
                                                      ]
                                                    }),
                                                JsxRuntime.jsxs("button", {
                                                      children: [
                                                        JsxRuntime.jsx("span", {
                                                              children: "+",
                                                              className: "mr-2 text-base"
                                                            }),
                                                        "Add your first config"
                                                      ],
                                                      className: "w-full sm:w-auto inline-flex items-center justify-center px-5 py-3 sm:py-2.5 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 shadow-sm min-h-[44px]",
                                                      onClick: (function (param) {
                                                          openCreateModal();
                                                        })
                                                    })
                                              ],
                                              className: "flex flex-col items-center max-w-sm mx-auto space-y-4 sm:space-y-5"
                                            }),
                                        className: "text-center py-10 sm:py-16 px-4 sm:px-6"
                                      }),
                                className: "overflow-x-auto"
                              })
                        ],
                        className: "bg-white rounded-lg sm:rounded-xl shadow border border-gray-200 overflow-hidden"
                      }),
                  JsxRuntime.jsx(ReportAutomailerModal$ReactHooksTemplate.make, {
                        show: state.showModal,
                        config: state.selectedConfig,
                        fromIds: state.fromIds,
                        reportOptions: state.reportOptions,
                        placeholderChips: state.placeholderChips,
                        roles: state.roles,
                        isFormValid: isFormValid,
                        onUpdate: (function (config) {
                            Curry._1(dispatch, {
                                  TAG: "SetSelectedConfig",
                                  _0: config
                                });
                          }),
                        onSubmit: onFormSubmit,
                        onClose: closeModal,
                        formAction: formActionStr,
                        validationErrors: state.formErrors,
                        nameTakenError: nameTakenErrorStr
                      })
                ],
                className: "w-full max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:py-8"
              });
  }
}

var make = ReportAutomailers;

exports.initialState = initialState;
exports.reducer = reducer;
exports.make = make;
/* initialState Not a pure module */
